(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/grassroots-shared/assets/javascripts/collections/grassroots.js') >= 0) return;  svs.modules.push('/modules/grassroots-shared/assets/javascripts/collections/grassroots.js');

(function(Backbone, _, svs) {
  'use strict';


  svs.grassroots.collections.Grassroots = Backbone.Collection.extend({
    initialize: function() {
      this.set(svs.grassroots.data.receiversCollection, { reset: true });
      this.orderBy = 'supporters';
    },

    orderTopList: function(orderBy) {
      this.orderBy = orderBy;
      this.sort();
      this.trigger('change');
    },

    comparator: function(model) {
      var order = this.orderBy;
      return -model.get(order);
    },

    addList: function(list, listType) {
      var collection = this;

      for (var o = 0; o < list.length; o++) {
        list[o][listType] = true;
      }

      for (var i = 0; i < collection.length; i++) {
        for (var j = list.length - 1; j >= 0; j--) {
          if (collection.models[i].id === list[j].id) {
            collection.models[i].attributes[listType] = true;
            list.splice(j, 1);
          }
        }
      }
      for (var k = 0; k < list.length; k++) {
        collection.push(list[k]);
      }
      this.trigger('change');
      this.sort();
    },

    removeFromList: function(id, type) {
      var self = this;
      var receiver = self.find(function(model) {
        return model.get('id') === parseInt(id, 10);
      });
      receiver.attributes[type] = false;
      this.trigger('change');
      this.sort();
    },

    addSupport: function(id, name, el) {
      var self = this;
      var options = {
        method: 'POST',
        path: '/player/1/sponsorship/receiverselection',
        data: {
          receivers: [id]
        }
      };
      options.data.omsKey = svs.grassroots.helpers.getOmsKey();
      svs.core.jupiter.call(
        options,
        function(response) {
          svs.ui.loader.hide();
          svs.grassroots.helpers.dialog.infoToaster({
            title: 'Tack',
            message: `Nu stödjer du ${name}.`
          });
          self.addList(response.receivers, 'myReceiver');
          svs.grassroots.models.my_receivers.set('hasReceivers', true);
          var evt = {
            category: 'Gräsroten',
            action: 'Ge mitt stöd',
            opt_label: name
          };
          svs.components.analytics.trackEvent(evt);
        },
        function(err) {
          svs.ui.loader.hide();
          var error = JSON.parse(err.responseText).error;

          switch (error.code) {
            case 10002: 
              if (
                _.find(self.where({ myReceiver: true }), function(model) {
                  return model.get(id) === parseInt(id, 10);
                })
              ) {
                svs.grassroots.helpers.dialog.errorToaster({
                  title: 'Fel',
                  message: `Du stödjer redan ${name}.`
                });
              } else {
                var currentReceivers = self.where({ myReceiver: true });
                var receiverToAdd = self.where({ id: id });
                var replaceReceiverModel = new svs.grassroots.models.ReplaceReceiver(
                  {
                    currentReceivers: currentReceivers,
                    receiverToAdd: receiverToAdd
                  },
                  { collection: self }
                );
                var replaceReceiverView = new svs.grassroots.views.ReplaceReceiver({ model: replaceReceiverModel });
                const receiverRoot = el.querySelector('.replace-receiver-root');
                el.querySelector('.js-add-support-btn').hidden = true;
                receiverRoot.appendChild(replaceReceiverView.render().el);
              }
              break;
            case 10004:
              svs.grassroots.helpers.dialog.errorToaster({
                title: 'Fel',
                message: `Du stödjer redan ${name}.`
              });
              break;
            default:
              svs.grassroots_logger.warn(
                'Set support for receiver error',
                svs.core.jupiter.parseErrorResponse(err)
              );
              svs.grassroots.helpers.dialog.errorPopup({
                title: 'Fel',
                message: `Kunde inte spara stöd till: ${name}. Försök igen senare.`
              });
          }
        }
      );
    },

    removeSupport: function(id, name) {
      var self = this;
      var options = {
        method: 'DELETE',
        path: '/player/1/sponsorship/receiverselection',
        data: {
          receivers: [id]
        }
      };

      svs.core.jupiter.call(
        options,
        function(response) {
          svs.ui.loader.hide();
          svs.grassroots.helpers.dialog.infoToaster({
            title: 'Tack',
            message: `Du har avslutat ditt stöd till ${name}.`
          });
          self.removeFromList(id, 'myReceiver');
          if (
            !response.receivers.length &&
            svs.grassroots.models.my_receivers
          ) {
            svs.grassroots.models.my_receivers.set('hasReceivers', false);
          }
          var evt = {
            category: 'Gräsroten',
            action: 'Avsluta mitt stöd',
            opt_label: name
          };
          svs.components.analytics.trackEvent(evt);
        },
        function(error) {
          svs.ui.loader.hide();
          svs.grassroots_logger.warn(
            'Delete support for receiver error',
            svs.core.jupiter.parseErrorResponse(error)
          );
          svs.grassroots.helpers.dialog.errorPopup({
            title: 'Fel',
            message: `Kunde inte avsluta stöd till ${name}. Försök igen senare`
          });
        }
      );
    },

    fetchMoreItems: function(listType, offset) {
      var self = this;
      var typeOfList = '';
      var orderBy = 'supporters';
      var options = {
        method: 'GET',
        path:
            String('/player/1/sponsorship/topselections?sortKey=' +
              listType +
              '&categories=' +
              encodeURIComponent('["Idrottsförening"]') +
              '&numRows=10&offset=' +
              offset)
      };
      svs.core.jupiter.call(
        options,
        function(data) {
          var receivers = data.categories[0].topSelections ?
            data.categories[0].topSelections :
            null;
          if (receivers.length) {
            switch (listType) {
              case 1:
                orderBy = 'points';
                typeOfList = 'topselectionPoints';
                break;
              case 2:
                orderBy = 'supporters';
                typeOfList = 'topselection';
                break;
              default:
            }
            svs.grassroots.helpers.populateYearlyStatistics(
              receivers,
              (result) => {
                self.addList(result, typeOfList);
                self.orderTopList(orderBy);
                svs.ui.loader.hide();
              },
              (error) => {
                svs.grassroots_logger.warn('Error fetching more items', error);
                svs.grassroots.helpers.dialog.errorToaster({
                  title: 'Fel',
                  message: 'Kunde inte hämta fler föreningar, försök igen.'
                });
                svs.ui.loader.hide();
              }
            );
          }
        },
        function(error) {
          svs.grassroots_logger.warn('Error fetching more items', error);
          svs.grassroots.helpers.dialog.errorToaster({
            title: 'Fel',
            message: 'Kunde inte hämta fler föreningar, försök igen.'
          });
          svs.ui.loader.hide();
        }
      );
    }
  });
})(Backbone, _, svs);


 })(window);